import { render } from "./agent-toolkit-nav-icon.vue.js?vue&type=template&id=91f76c1d!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./agent-toolkit-nav-icon.vue?vue&type=template&id=91f76c1d"
const script = {}

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__